<template>
  <div v-show="false">
    <DetailsModal ref="detailsModal" :processes="processes" :clients="clients" @closed="onDetailsModalClosed"
      @hidden="onDetailsModalHidden" />
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState, mapGetters, mapActions } from 'vuex'
import DetailsModal from '@/views/configuration/components/configurationCopy/modais/DetailsModal.vue'

export default {
  name: 'DMCopyNotification',

  components: {
    DetailsModal
  },

  data() {
    return {
      alertShown: false
    }
  },

  computed: {
    ...mapState('copyProcesses', ['processes', 'detailsModalClosedByUser', 'clients']),
    ...mapState('currentConfigurationCopyTabIndex', ['currentConfigurationCopyTabIndex']),
    ...mapGetters('copyProcesses', ['allCompleted', 'hasActiveProcesses']),

    isOnCopyTab() {
      return this.currentConfigurationCopyTabIndex === 0
    }
  },

  mounted() {
    this.$root.$on('open-copy-details-modal', this.openDetailsModal)

    this.$watch('processes', (newVal, oldVal) => {
      if (newVal.length > 0 && oldVal.length === 0) {
        this.alertShown = false
      }
    })
  },

  beforeDestroy() {
    this.$root.$off('open-copy-details-modal', this.openDetailsModal)
  },

  sockets: {
    connect() {
      // Socket conectado
    },

    copyProgress(data) {
      this.updateProcessProgress({
        room: data.room,
        message: data.message,
        messageKey: data.messageKey,
        messageParams: data.messageParams,
        progress: data.progress || 0,
        processed: data.processed || 0,
        total: data.total || 0,
        results: data.results
      })
    },

    copyCompleted(data) {
      this.markProcessCompleted({
        room: data.room,
        results: data.results
      })

      this.$nextTick(() => {
        if (this.allCompleted && this.hasActiveProcesses && !this.alertShown) {

          const shouldShowAlert = this.detailsModalClosedByUser || !this.isOnCopyTab

          if (shouldShowAlert) {
            this.alertShown = true
            this.showCompletionAlert()
          }
        }
      })
    },

    copyFailed(data) {
      this.markProcessFailed({
        room: data.room,
        error: data.error
      })

      this.$nextTick(() => {
        if (this.allCompleted && this.hasActiveProcesses && !this.alertShown) {
          const shouldShowAlert = this.detailsModalClosedByUser || !this.isOnCopyTab

          if (shouldShowAlert) {
            this.alertShown = true
            this.showCompletionAlert()
          }
        }
      })
    }
  },

  methods: {
    ...mapActions('copyProcesses', [
      'updateProcessProgress',
      'markProcessCompleted',
      'markProcessFailed',
      'setDetailsModalClosedByUser',
      'clearProcesses'
    ]),

    openDetailsModal() {
      if (!this.hasActiveProcesses) {
        return
      }

      if (!this.$refs.detailsModal) {
        return
      }

      this.$refs.detailsModal.show()
    },

    onDetailsModalClosed() {
      const allCompleted = this.hasActiveProcesses && this.processes.every(p => p.status === 'success' || p.status === 'error')
      if (this.hasActiveProcesses && allCompleted) {
        this.alertShown = false
        this.clearProcesses()
      }
    },

    onDetailsModalHidden() {
      const hasProcessing = this.processes.some(p => p.status === 'processing')
      if (hasProcessing) {
        this.setDetailsModalClosedByUser(true)
      }
    },

    showCompletionAlert() {
      const hasError = this.processes.some(p => p.status === 'error')

      if (hasError) {
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: this.$t('copiafalhou'),
          text: this.$t('erroaoprocessarcopia'),
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonColor: '#53933a',
          confirmButtonText: 'OK'
        }).then(() => {
          this.alertShown = false
          this.clearProcesses()
        })
      } else {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: this.$t('copiaconcluidasucesso'),
          text: this.$t('cliquenobotaookparavisualizaroresumocopia'),
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonColor: '#53933a',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            this.setDetailsModalClosedByUser(false)

            this.$nextTick(() => {
              this.openDetailsModal()
            })
          } else {
            this.alertShown = false
            this.clearProcesses()
          }
        })
      }
    }
  }
}
</script>
